export default __webpack_public_path__ + "static/media/z030mi0b.198a2dfe.mp3";